import { Api } from "../../../api/api";

export class S25BulkEditSaveApi extends Api {
    //Puts the save component back to original view state
    public static reset(parentElm: HTMLElement) {
        Api.callApiFn(parentElm, "s25-ng-bulk-edit-save", "reset");
    }
}
